var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd-modal-overlay"},[_c('div',{staticClass:"asd-modal"},[_c('div',{staticClass:"asd-modal-title"},[_vm._t("default")],2),_c('div',{staticClass:"asd-modal-controls"},[_vm._t("controls")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }